module.exports = __webpack_public_path__ + "img/1F1F8-1F1EE.60153f33.svg";